var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03999 19.5201C5.42999 19.5201 4.85999 19.31 4.44999 18.92C3.92999 18.43 3.67999 17.69 3.76999 16.89L4.13999 13.65C4.20999 13.04 4.57999 12.23 5.00999 11.79L13.22 3.10005C15.27 0.930049 17.41 0.870049 19.58 2.92005C21.75 4.97005 21.81 7.11005 19.76 9.28005L11.55 17.97C11.13 18.42 10.35 18.84 9.73999 18.9401L6.51999 19.49C6.34999 19.5 6.19999 19.5201 6.03999 19.5201ZM16.43 2.91005C15.66 2.91005 14.99 3.39005 14.31 4.11005L6.09999 12.8101C5.89999 13.0201 5.66999 13.5201 5.62999 13.8101L5.25999 17.05C5.21999 17.38 5.29999 17.65 5.47999 17.82C5.65999 17.99 5.92999 18.05 6.25999 18L9.47999 17.4501C9.76999 17.4001 10.25 17.14 10.45 16.93L18.66 8.24005C19.9 6.92005 20.35 5.70005 18.54 4.00005C17.74 3.23005 17.05 2.91005 16.43 2.91005Z",
    fill: "#4F5B92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8399 10.9501C17.8199 10.9501 17.7899 10.9501 17.7699 10.9501C14.6499 10.6401 12.1399 8.27009 11.6599 5.17009C11.5999 4.76009 11.8799 4.38009 12.2899 4.31009C12.6999 4.25009 13.0799 4.53009 13.1499 4.94009C13.5299 7.36009 15.4899 9.22009 17.9299 9.46009C18.3399 9.50009 18.6399 9.87009 18.5999 10.2801C18.5499 10.6601 18.2199 10.9501 17.8399 10.9501Z",
    fill: "#4F5B92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 22.75H3.5C3.09 22.75 2.75 22.41 2.75 22C2.75 21.59 3.09 21.25 3.5 21.25H21.5C21.91 21.25 22.25 21.59 22.25 22C22.25 22.41 21.91 22.75 21.5 22.75Z",
    fill: "#4F5B92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.065af8005de54235e30f62f7e8f7413f.svg";
export { ForwardRef as ReactComponent };